module.exports = __webpack_public_path__ + "img/as.3ab2ce25.png";